import { TabStack } from '@/components/TabStack';

export default function CommunityTabLayout() {
  return <TabStack tab="community" />;
}
